import React from 'react';
import { motion } from 'framer-motion';

const FilterBar = ({ filter, setFilter }) => {
  const filters = [
    { key: 'all', label: 'All Tasks', color: 'text-gray-600' },
    { key: 'active', label: 'Active', color: 'text-orange-600' },
    { key: 'completed', label: 'Completed', color: 'text-green-600' },
    { key: 'high', label: 'High Priority', color: 'text-red-600' }
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {filters.map(({ key, label, color }) => (
        <motion.button
          key={key}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setFilter(key)}
          className={`px-4 py-2 rounded-xl font-medium transition-all duration-200 ${
            filter === key
              ? 'bg-blue-100 text-blue-700 shadow-md'
              : `bg-gray-100 hover:bg-gray-200 ${color}`
          }`}
        >
          {label}
        </motion.button>
      ))}
    </div>
  );
};

export default FilterBar;